import AL from '@/assets/svg/flags/al.svg';
import EN from '@/assets/svg/flags/en.svg';
import { GlobalOutlined } from '@ant-design/icons';
import { SelectLang as LibSelectLang, setLocale } from '@umijs/max';
import { useEffect } from 'react';
import styles from './index.less';

interface LocalData {
    lang: string;
    label?: string;
    icon?: any;
    title?: string;
}

const newLocaleData: LocalData[] = [
    {
        lang: 'en-US',
        label: 'English',
        icon: <img width={20} height={20} src={EN} alt="en" />,
        title: 'English',
    },
    {
        lang: 'sq-AL',
        label: 'Albanian',
        icon: <img width={20} height={20} src={AL} alt="al" />,
        title: 'Albanian',
    },
];

const SelectLang: React.FC = () => {
    useEffect(() => {
        // Set albanian as default on mount
        setLocale('sq-AL', false);
    }, []);

    return (
        <LibSelectLang
            icon={<GlobalOutlined style={{ color: '#005CA9' }} />}
            className={styles.action}
            reload={false}
            postLocalesData={(localData: LocalData[]) => {
                return newLocaleData;
            }}
        />
    );
};

export default SelectLang;
